import { Monitor, Smartphone } from "lucide-react";

export const API = "/api";

export const CATEGORIES = [
  { id: "standard", name: "Стандарт" },
  { id: "medium", name: "Медиум" },
  { id: "premium", name: "Премиум" },
];

export const CITIES = [
  { slug: "antalya", name: "Анталья", currency: "$" },
  { slug: "alanya", name: "Алания", currency: "$" },
  { slug: "istanbul", name: "Стамбул", currency: "$" },
  { slug: "alicante", name: "Аликанте", currency: "€" },
  { slug: "barcelona", name: "Барселона", currency: "€" },
  { slug: "bodrum", name: "Бодрум", currency: "$" },
  { slug: "marmaris", name: "Мармарис", currency: "$" },
  { slug: "ibiza", name: "Ибица", currency: "€" },
  { slug: "phuket", name: "Пхукет", currency: "$" },
  { slug: "monaco", name: "Монако", currency: "€" },
  { slug: "dubai", name: "Дубай", currency: "$" },
  { slug: "mykonos", name: "Миконос", currency: "€" },
  { slug: "santorini", name: "Санторини", currency: "€" },
  { slug: "rhodes", name: "Родос", currency: "€" },
  { slug: "crete", name: "Крит", currency: "€" },
  { slug: "nice", name: "Ницца", currency: "€" },
  { slug: "cannes", name: "Канны", currency: "€" },
  { slug: "miami", name: "Майами", currency: "$" },
  { slug: "saint-tropez", name: "Сен-Тропе", currency: "€" },
  { slug: "valencia", name: "Валенсия", currency: "€" },
];

export const CITY_NAMES = {
  antalya: "Анталья", alanya: "Алания", istanbul: "Стамбул",
  alicante: "Аликанте", barcelona: "Барселона", bodrum: "Бодрум", marmaris: "Мармарис", ibiza: "Ибица", phuket: "Пхукет", monaco: "Монако", dubai: "Дубай", mykonos: "Миконос", santorini: "Санторини", rhodes: "Родос", crete: "Крит", malaga: "Малага", nice: "Ницца", cannes: "Канны", miami: "Майами", "saint-tropez": "Сен-Тропе", valencia: "Валенсия",
};

export const BUTTON_NAMES = { whatsapp: "WhatsApp", telegram: "Telegram" };

export const SOURCE_NAMES = {
  direct: "Прямой заход", google: "Google", yandex: "Яндекс", bing: "Bing", duckduckgo: "DuckDuckGo",
  chatgpt: "ChatGPT", perplexity: "Perplexity", claude: "Claude", gemini: "Gemini", copilot: "Copilot",
  telegram: "Telegram", whatsapp: "WhatsApp", facebook: "Facebook",
  instagram: "Instagram", vk: "ВКонтакте", internal: "Внутренний", other: "Другое",
};

export const AI_SOURCES = ["chatgpt", "perplexity", "claude", "gemini", "copilot"];

export const DEVICE_ICONS = { desktop: Monitor, mobile: Smartphone, tablet: Smartphone };

export const PRIORITY_COLORS = {
  P1: "bg-red-50 text-red-600 border-red-200",
  P2: "bg-amber-50 text-amber-600 border-amber-200",
  P3: "bg-blue-50 text-blue-600 border-blue-200",
};

export const CONTENT_PLAN = [
  {
    city: "antalya",
    cityName: "Анталья",
    priority: "P1",
    articles: [
      { slug: "dostavka-cvetov-antalya", titleRu: "Доставка цветов в Анталье — как заказать букет быстро и недорого", titleEn: "Flower Delivery in Antalya — How to Order a Bouquet Quickly and Affordably" },
      { slug: "kakie-cvety-podarit-devushke-turcia", titleRu: "Какие цветы подарить девушке в Турции — гид по букетам", titleEn: "What Flowers to Give a Girl in Turkey — Bouquet Guide" },
      { slug: "bukety-na-den-rozhdeniya-antalya", titleRu: "Лучшие букеты на день рождения с доставкой в Анталье", titleEn: "Best Birthday Bouquets with Delivery in Antalya" },
      { slug: "rozy-antalya-dostavka", titleRu: "Розы в Анталье — свежие букеты роз с доставкой сегодня", titleEn: "Roses in Antalya — Fresh Rose Bouquets Same-Day Delivery" },
      { slug: "cvety-na-svadbu-antalya", titleRu: "Свадебные цветы в Анталье — букет невесты и оформление", titleEn: "Wedding Flowers in Antalya — Bridal Bouquets & Decor" },
      { slug: "cvety-na-8-marta-antalya", titleRu: "Цветы на 8 марта в Анталье — что подарить и где заказать", titleEn: "Flowers for Women's Day in Antalya — What to Give & Where to Order" },
      { slug: "piony-antalya", titleRu: "Пионы в Анталье — сезон, цены и доставка", titleEn: "Peonies in Antalya — Season, Prices & Delivery" },
      { slug: "cvety-v-korobke-antalya", titleRu: "Цветы в коробке — стильный подарок с доставкой в Анталье", titleEn: "Flowers in a Box — Stylish Gift Delivery in Antalya" },
      { slug: "nochnaya-dostavka-cvetov-antalya", titleRu: "Ночная доставка цветов в Анталье — сюрприз в любое время", titleEn: "Night Flower Delivery in Antalya — Surprise Anytime" },
      { slug: "sravnenie-cvetochnyh-magazinov-antalya", titleRu: "Цветочные магазины в Анталье — сравнение цен и сервиса", titleEn: "Flower Shops in Antalya — Price and Service Comparison" },
      { slug: "cvety-v-otel-antalya", titleRu: "Доставка цветов в отель в Анталье — сюрприз для гостей", titleEn: "Hotel Flower Delivery in Antalya — Guest Surprise" },
      { slug: "dostavka-cvetov-antalya-rajony-gid", titleRu: "Доставка цветов в Анталье — гид по районам, отелям и сезонным букетам", titleEn: "Flower Delivery in Antalya — A Guide to Districts, Hotels and Seasonal Bouquets" },
      { slug: "dostavka-cvetov-na-turetskom-poberezhe", titleRu: "Доставка цветов на побережье Турции 2026: гид по курортам Средиземного и Эгейского моря", titleEn: "Flower Delivery on the Turkish Coast 2026: A Guide to the Mediterranean and Aegean Resorts" },
      { slug: "gortenzii-antalya", titleRu: "Гортензии в Анталье — пышные букеты с доставкой", titleEn: "Hydrangeas in Antalya — Lush Bouquets Delivered" },
      { slug: "orhidei-antalya", titleRu: "Орхидеи в Анталье — элегантный подарок с долгим цветением", titleEn: "Orchids in Antalya — Elegant Long-Lasting Gift" },
      { slug: "cvety-na-godovshchinu-antalya", titleRu: "Цветы на годовщину свадьбы в Анталье — идеи букетов", titleEn: "Anniversary Flowers in Antalya — Bouquet Ideas" },
      { slug: "cvety-na-vypisku-antalya", titleRu: "Цветы на выписку из роддома в Анталье", titleEn: "New-Baby & Discharge Flowers in Antalya" },
    ],
  },
  {
    city: "alanya",
    cityName: "Алания",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-alanya", titleRu: "Доставка цветов в Аланье — свежие букеты с доставкой за 2 часа", titleEn: "Flower Delivery in Alanya — Fresh Bouquets in 2 Hours" },
      { slug: "cvety-na-den-valentina-alanya", titleRu: "Цветы на День Святого Валентина в Аланье", titleEn: "Valentine's Day Flowers in Alanya" },
      { slug: "bukety-dlya-turistov-alanya", titleRu: "Букеты для туристов в Аланье — подарок на отдыхе", titleEn: "Bouquets for Tourists in Alanya — Holiday Gift" },
      { slug: "den-rozhdeniya-v-alane-gde-otmetit-i-kak-organizovat-syurpriz", titleRu: "День рождения в Аланье — где отметить и как организовать сюрприз", titleEn: "Birthday in Alanya — Where to Celebrate and How to Organize a Surprise" },
      { slug: "rozy-v-alane-krasnye-belye-miks-s-dostavkoy", titleRu: "Розы в Аланье — красные, белые, микс с доставкой", titleEn: "Roses in Alanya — Red, White, Mix with Delivery" },
      { slug: "cvety-na-den-rozhdeniya-alanye-top-buketov", titleRu: "Цветы на день рождения в Аланье — топ букетов с доставкой", titleEn: "Birthday Flowers in Alanya — Top Bouquets with Delivery" },
      { slug: "cvety-na-godovshchinu-alanya", titleRu: "Цветы на годовщину в Аланье — романтический сюрприз", titleEn: "Anniversary Flowers in Alanya — Romantic Surprise" },
      { slug: "cvety-v-otel-alanya", titleRu: "Доставка цветов в отель в Аланье — удивите близких", titleEn: "Hotel Flower Delivery in Alanya" },
      { slug: "cvety-na-8-marta-alanya", titleRu: "Цветы на 8 марта в Аланье — тюльпаны и мимоза", titleEn: "Women's Day Flowers in Alanya — Tulips & Mimosa" },
    ],
  },
  {
    city: "istanbul",
    cityName: "Стамбул",
    priority: "P1",
    articles: [
      { slug: "dostavka-cvetov-stambul", titleRu: "Доставка цветов в Стамбуле — все районы, быстро и свежо", titleEn: "Flower Delivery in Istanbul — All Districts, Fast & Fresh" },
      { slug: "cvety-na-den-rozhdeniya-stambul", titleRu: "Цветы на день рождения в Стамбуле — топ букетов с доставкой", titleEn: "Birthday Flowers in Istanbul — Top Bouquets with Delivery" },
      { slug: "cvety-aziatskaya-storona-stambul", titleRu: "Доставка цветов на азиатскую сторону Стамбула", titleEn: "Flower Delivery to the Asian Side of Istanbul" },
      { slug: "rozy-stambul-dostavka", titleRu: "Розы в Стамбуле — свежие букеты роз с доставкой по всему городу", titleEn: "Roses in Istanbul — Fresh Rose Bouquets Delivered Across the City" },
      { slug: "svadebnye-cvety-stambul", titleRu: "Свадебные цветы в Стамбуле — букет невесты, декор и оформление", titleEn: "Wedding Flowers in Istanbul — Bridal Bouquets, Decor & Venue Styling" },
      { slug: "restorany-stambula-dlya-delovogo-uzhina", titleRu: "Рестораны Стамбула для делового ужина — где впечатлить партнёра", titleEn: "Istanbul Restaurants for a Business Dinner — Where to Impress Your Partner" },
      { slug: "piony-v-stambule-simvol-goroda", titleRu: "Пионы в Стамбуле — символ города с доставкой", titleEn: "Peonies in Istanbul — A Symbol of the City with Delivery" },
      { slug: "dostavka-cvetov-stambul-rajony-gid", titleRu: "Доставка цветов в Стамбуле — гид по районам, отелям и сезонным букетам", titleEn: "Flower Delivery in Istanbul — A Guide to Districts, Hotels and Seasonal Bouquets" },
      { slug: "koncerty-v-stambule-kanye-west-max-korzh", titleRu: "Концерты в Стамбуле: от Канье Уэста до Макса Коржа — и как цветы делают вечер незабываемым", titleEn: "Concerts in Istanbul: From Kanye West to Max Korzh — and How Flowers Make the Night Unforgettable" },
      { slug: "bukety-v-stambule", titleRu: "Букеты в Стамбуле 2026 — какие цветы заказать и как доставить по районам", titleEn: "Bouquets in Istanbul 2026 — Which Flowers to Order and How to Deliver by District" },
      { slug: "tyulpany-stambul", titleRu: "Тюльпаны в Стамбуле — символ города с доставкой", titleEn: "Tulips in Istanbul — City Symbol Delivered" },
      { slug: "cvety-na-8-marta-stambul", titleRu: "Цветы на 8 марта в Стамбуле — что подарить", titleEn: "Women's Day Flowers in Istanbul" },
      { slug: "cvety-v-bolnicu-stambul", titleRu: "Доставка цветов в больницу в Стамбуле", titleEn: "Hospital Flower Delivery in Istanbul" },
      { slug: "korporativnye-bukety-stambul", titleRu: "Корпоративные букеты в Стамбуле — офис и мероприятия", titleEn: "Corporate Bouquets in Istanbul" },
    ],
  },
  {
    city: "bodrum",
    cityName: "Бодрум",
    priority: "P1",
    articles: [
      { slug: "dostavka-cvetov-bodrum", titleRu: "Доставка цветов в Бодруме — букеты на побережье Эгейского моря", titleEn: "Flower Delivery in Bodrum — Bouquets on the Aegean Coast" },
      { slug: "svadebnye-cvety-bodrum", titleRu: "Свадебные цветы в Бодруме — букеты для церемоний на Эгейском побережье", titleEn: "Wedding Flowers in Bodrum — Bouquets for Aegean Coast Ceremonies" },
      { slug: "rozy-bodrum", titleRu: "Розы в Бодруме — классические букеты с доставкой", titleEn: "Roses in Bodrum — Classic Bouquets Delivered" },
      { slug: "luchshie-oteli-bodrum-2026", titleRu: "Лучшие отели Бодрума 2026: где остановиться (и как удивить цветами)", titleEn: "Best Hotels in Bodrum 2026: Where to Stay (and How to Surprise with Flowers)" },
      { slug: "luchshie-plyazhi-bodruma", titleRu: "Лучшие пляжи Бодрума 2026 — от тусовочных до уединённых: честное сравнение", titleEn: "Best Beaches in Bodrum 2026 — From Party to Secluded: An Honest Comparison" },
      { slug: "cvety-na-yakhtu-bodrum", titleRu: "Цветы на яхту в Бодруме — романтика на воде", titleEn: "Yacht Flowers in Bodrum — Romance on Water" },
      { slug: "cvety-yalikavak-bodrum", titleRu: "Доставка цветов в Ялыкавак — бутики и марина", titleEn: "Flower Delivery to Yalikavak — Boutiques & Marina" },
      { slug: "letnie-bukety-bodrum", titleRu: "Летние букеты в Бодруме — подсолнухи и полевые цветы", titleEn: "Summer Bouquets in Bodrum — Sunflowers & Wildflowers" },
    ],
  },
  {
    city: "marmaris",
    cityName: "Мармарис",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-marmaris", titleRu: "Доставка цветов в Мармарисе — свежие букеты на курорте", titleEn: "Flower Delivery in Marmaris — Fresh Bouquets at the Resort" },
      { slug: "cvety-v-otel-marmaris", titleRu: "Доставка цветов в отель в Мармарисе — сюрприз на отдыхе", titleEn: "Hotel Flower Delivery in Marmaris — Holiday Surprise" },
      { slug: "rozy-marmaris", titleRu: "Розы в Мармарисе — красные, белые, микс", titleEn: "Roses in Marmaris — Red, White, Mix" },
      { slug: "cvety-icmeler-marmaris", titleRu: "Доставка цветов в Ичмелер — бухта роз", titleEn: "Flower Delivery to Icmeler" },
      { slug: "cvety-na-svadbu-marmaris", titleRu: "Свадебные букеты в Мармарисе — на фоне бухты", titleEn: "Wedding Bouquets in Marmaris" },
    ],
  },
  {
    city: "fethiye",
    cityName: "Фетхие",
    priority: "P2",
    articles: [
      { slug: "kak-zakazat-cvety-v-fethiye", titleRu: "Как заказать цветы в Фетхие 2026: пошаговый гид по доставке букетов", titleEn: "How to Order Flowers in Fethiye 2026: A Step-by-Step Flower Delivery Guide" },
      { slug: "rozy-fethiye", titleRu: "Розы в Фетхие — свежие букеты с доставкой", titleEn: "Roses in Fethiye — Fresh Bouquets Delivered" },
      { slug: "cvety-na-yahtu-fethiye-gocek", titleRu: "Цветы на яхту в Фетхие и Гёчек — сюрприз на воде", titleEn: "Yacht Flowers in Fethiye & Gocek" },
      { slug: "cvety-v-otel-fethiye-oludeniz", titleRu: "Доставка цветов в отель в Олюденизе и Фетхие", titleEn: "Hotel Flower Delivery in Oludeniz & Fethiye" },
      { slug: "svadba-fethiye-cvety", titleRu: "Свадебные цветы в Фетхие — церемония у моря", titleEn: "Wedding Flowers in Fethiye" },
    ],
  },
  {
    city: "kemer",
    cityName: "Кемер",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-kemer", titleRu: "Доставка цветов в Кемере — букеты в отели с доставкой", titleEn: "Flower Delivery in Kemer — Bouquets to Hotels" },
      { slug: "cvety-v-otel-kemer", titleRu: "Доставка цветов в отель в Кемере — Rixos, Maxx Royal", titleEn: "Hotel Flower Delivery in Kemer" },
      { slug: "rozy-kemer", titleRu: "Розы в Кемере — свежие букеты роз с доставкой", titleEn: "Roses in Kemer — Fresh Rose Bouquets" },
      { slug: "svadba-kemer-cvety", titleRu: "Свадебные цветы в Кемере — церемония в горах и у моря", titleEn: "Wedding Flowers in Kemer" },
    ],
  },
  {
    city: "cesme",
    cityName: "Чешме",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-cesme", titleRu: "Доставка цветов в Чешме — букеты на Эгейском полуострове", titleEn: "Flower Delivery in Cesme — Aegean Peninsula Bouquets" },
      { slug: "cvety-alacati-cesme", titleRu: "Доставка цветов в Алачаты — букеты среди каменных улочек", titleEn: "Flower Delivery to Alacati" },
      { slug: "cvety-na-yahtu-cesme-marina", titleRu: "Цветы на яхту в марине Чешме — сюрприз на воде", titleEn: "Yacht Flowers at Cesme Marina" },
      { slug: "svadba-cesme-cvety", titleRu: "Свадебные цветы в Чешме — виноградники и море", titleEn: "Wedding Flowers in Cesme" },
    ],
  },
  {
    city: "mersin",
    cityName: "Мерсин",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-mersin", titleRu: "Доставка цветов в Мерсине — свежие букеты с доставкой", titleEn: "Flower Delivery in Mersin — Fresh Bouquets" },
      { slug: "rozy-mersin", titleRu: "Розы в Мерсине — букеты роз с доставкой по городу", titleEn: "Roses in Mersin — Rose Bouquets Delivered" },
      { slug: "cvety-na-den-rozhdeniya-mersin", titleRu: "Цветы на день рождения в Мерсине — топ букетов", titleEn: "Birthday Flowers in Mersin" },
      { slug: "cvety-v-otel-mersin", titleRu: "Доставка цветов в отель в Мерсине", titleEn: "Hotel Flower Delivery in Mersin" },
    ],
  },
  {
    city: "dubai",
    cityName: "Дубай",
    priority: "P1",
    articles: [
      { slug: "dostavka-tsvetov-v-dubae-bukety", titleRu: "Доставка цветов в Дубае — букеты в самом амбициозном городе мира", titleEn: "Flower Delivery in Dubai — Bouquets in the World's Most Ambitious City" },
      { slug: "rozy-dubai", titleRu: "Розы в Дубае — от 25 до 501 розы с доставкой", titleEn: "Roses in Dubai — From 25 to 501 Roses Delivered" },
      { slug: "dostavka-cvetov-dubai-marina", titleRu: "Доставка цветов в Дубай Марина — пляжи и резиденции", titleEn: "Flower Delivery to Dubai Marina" },
      { slug: "cvety-v-otel-dubai", titleRu: "Доставка цветов в отель в Дубае — Burj Al Arab, Atlantis", titleEn: "Hotel Flower Delivery in Dubai" },
      { slug: "svadebnye-cvety-dubai", titleRu: "Свадебные цветы в Дубае — оформление и букет невесты", titleEn: "Wedding Flowers in Dubai" },
      { slug: "korporativnye-bukety-dubai", titleRu: "Корпоративные букеты в Дубае — DIFC и Business Bay", titleEn: "Corporate Bouquets in Dubai" },
    ],
  },
  {
    city: "phuket",
    cityName: "Пхукет",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-phuket", titleRu: "Доставка цветов на Пхукете — свежие букеты на острове", titleEn: "Flower Delivery in Phuket — Fresh Bouquets on the Island" },
      { slug: "cvety-v-otel-phuket", titleRu: "Доставка цветов в отель на Пхукете — сюрприз для гостей", titleEn: "Hotel Flower Delivery in Phuket — A Surprise for Guests" },
      { slug: "luchshie-restorany-phuket", titleRu: "Лучшие рестораны Пхукета для романтического ужина — где провести вечер вдвоём", titleEn: "Best Restaurants in Phuket for a Romantic Dinner — Where to Spend an Evening for Two" },
      { slug: "den-rozhdeniya-na-phukete", titleRu: "День рождения на Пхукете — где отметить и как удивить", titleEn: "A Birthday in Phuket — Where to Celebrate and How to Surprise" },
      { slug: "patong-karon-kata-dostavka", titleRu: "Доставка цветов в Патонг, Карон и Ката — все пляжи Пхукета 2026", titleEn: "Flower Delivery to Patong, Karon & Kata — All Phuket Beaches 2026" },
      { slug: "tropicheskie-bukety-phuket", titleRu: "Тропические букеты на Пхукете — орхидеи и франжипани", titleEn: "Tropical Bouquets in Phuket" },
      { slug: "svadba-na-phukete-cvety", titleRu: "Свадебные цветы на Пхукете — тропическое оформление", titleEn: "Wedding Flowers in Phuket" },
      { slug: "cvety-dlya-russkoyazychnyh-phuket", titleRu: "Цветы для русскоязычных на Пхукете — заказ на русском", titleEn: "Flowers for Russian Speakers in Phuket" },
    ],
  },
  {
    city: "danang",
    cityName: "Дананг",
    priority: "P2",
    articles: [
      { slug: "kak-zakazat-cvety-v-danange", titleRu: "Как заказать цветы в Дананге 2026 — пошаговый гид по доставке букетов", titleEn: "How to Order Flowers in Da Nang 2026 — A Step-by-Step Delivery Guide" },
      { slug: "cvety-v-otel-danang", titleRu: "Доставка цветов в отель в Дананге — Ми Кхе и Сон Тра", titleEn: "Hotel Flower Delivery in Da Nang" },
      { slug: "rozy-danang", titleRu: "Розы в Дананге — свежие букеты роз с доставкой", titleEn: "Roses in Da Nang — Fresh Rose Bouquets" },
      { slug: "predlozhenie-danang-cvety", titleRu: "Предложение руки и сердца в Дананге — букет и сюрприз", titleEn: "Marriage Proposal in Da Nang" },
      { slug: "svadba-danang-hoian-cvety", titleRu: "Свадебные цветы в Дананге и Хойане", titleEn: "Wedding Flowers in Da Nang & Hoi An" },
    ],
  },
  {
    city: "nhatrang",
    cityName: "Нячанг",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-nhatrang", titleRu: "Доставка цветов в Нячанге — свежие букеты от $89 сегодня", titleEn: "Flower Delivery in Nha Trang — Fresh Bouquets from $89 Today" },
      { slug: "cvety-v-otel-nhatrang", titleRu: "Доставка цветов в отель в Нячанге — набережная Чан Фу", titleEn: "Hotel Flower Delivery in Nha Trang — Tran Phu" },
      { slug: "rozy-nhatrang", titleRu: "Розы в Нячанге — свежие букеты роз с доставкой", titleEn: "Roses in Nha Trang — Fresh Rose Bouquets" },
      { slug: "predlozhenie-nhatrang-cvety", titleRu: "Предложение руки и сердца в Нячанге — букет и сюрприз у моря", titleEn: "Marriage Proposal in Nha Trang" },
      { slug: "cvety-na-den-rozhdeniya-nhatrang", titleRu: "Цветы на день рождения в Нячанге — топ букетов", titleEn: "Birthday Flowers in Nha Trang" },
    ],
  },
  {
    city: "barcelona",
    cityName: "Барселона",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-barcelona", titleRu: "Доставка цветов в Барселоне: как заказать букет из любой страны, районы, отели, адреса и реальные цены", titleEn: "Flower Delivery in Barcelona: How to Order a Bouquet from Abroad — Districts, Hotels, Addresses and Real Prices" },
      { slug: "flores-sant-jordi-barcelona", titleRu: "Розы на Сант Жорди в Барселоне: как заказать доставку 23 апреля, традиция, сроки и реальные цены", titleEn: "Sant Jordi Roses in Barcelona: How to Order Delivery for 23 April — the Tradition, Lead Times and Real Prices" },
      { slug: "cvety-na-svadbu-barcelona", titleRu: "Свадебные букеты в Барселоне: средиземноморский стиль, площадки, сроки, цены и как заказать из другой страны", titleEn: "Wedding Bouquets in Barcelona: Mediterranean Style, Venues, Lead Times, Prices and How to Order from Abroad" },
      { slug: "dostavka-cvetov-v-ispanii", titleRu: "Доставка цветов в Испании 2026: полный гид по всем городам", titleEn: "Flower Delivery in Spain 2026: The Complete City-by-City Guide" },
      { slug: "rozy-barcelona", titleRu: "Розы в Барселоне — испанские и импортные с доставкой", titleEn: "Roses in Barcelona" },
      { slug: "cvety-na-den-materi-barcelona", titleRu: "Букеты на День матери в Барселоне", titleEn: "Mother's Day Bouquets in Barcelona" },
      { slug: "cvety-v-otel-barcelona", titleRu: "Доставка цветов в отель в Барселоне", titleEn: "Hotel Flower Delivery in Barcelona" },
    ],
  },
  {
    city: "alicante",
    cityName: "Аликанте",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-alikante", titleRu: "Доставка цветов в Аликанте — букеты для Коста Бланки", titleEn: "Flower Delivery in Alicante — Bouquets for Costa Blanca" },
      { slug: "luchshie-restorany-alikante-dlya-romanticheskogo-uzhina", titleRu: "Лучшие рестораны Аликанте для романтического ужина — где стоит побывать", titleEn: "Best Restaurants in Alicante for a Romantic Dinner — Where to Go" },
      { slug: "ekzoticheskie-cvety-alikante", titleRu: "Экзотические цветы в Аликанте — орхидеи и тропические букеты", titleEn: "Exotic Flowers in Alicante — Orchids and Tropical Bouquets" },
      { slug: "rozy-alikante", titleRu: "Розы в Аликанте — свежие букеты с доставкой", titleEn: "Roses in Alicante — Fresh Bouquets Delivered" },
      { slug: "cvety-costa-blanca", titleRu: "Доставка цветов на Коста-Бланка — Аликанте и окрестности", titleEn: "Flower Delivery Costa Blanca" },
      { slug: "cvety-na-svadbu-alikante", titleRu: "Свадебные букеты в Аликанте — стиль Коста-Бланки", titleEn: "Wedding Bouquets in Alicante" },
      { slug: "cvety-v-otel-alikante", titleRu: "Доставка цветов в отель в Аликанте", titleEn: "Hotel Flower Delivery in Alicante" },
    ],
  },
  {
    city: "valencia",
    cityName: "Валенсия",
    priority: "P3",
    articles: [
      { slug: "pochemu-valencia-nedoocenena", titleRu: "Паэлья, Фальяс и море: почему Валенсия недооценена туристами", titleEn: "Paella, Las Fallas and the Sea: Why Valencia Is Underrated by Tourists" },
      { slug: "dostavka-cvetov-valencia", titleRu: "Доставка цветов в Валенсии — свежие букеты с доставкой", titleEn: "Flower Delivery in Valencia" },
      { slug: "rozy-valencia", titleRu: "Розы в Валенсии — букеты роз с доставкой", titleEn: "Roses in Valencia" },
      { slug: "cvety-na-fallas-valencia", titleRu: "Цветы на Лас-Фальяс в Валенсии — traditions и букеты", titleEn: "Flowers for Las Fallas in Valencia" },
    ],
  },
  {
    city: "malaga",
    cityName: "Малага",
    priority: "P3",
    articles: [
      { slug: "kak-zakazat-cvety-v-malage", titleRu: "Цветы в Малаге 2026: как заказать доставку букетов — полный гид", titleEn: "Flowers in Malaga 2026: How to Order Bouquet Delivery — A Complete Guide" },
      { slug: "dostavka-cvetov-malaga", titleRu: "Доставка цветов в Малаге — букеты на Коста-дель-Соль", titleEn: "Flower Delivery in Malaga" },
      { slug: "rozy-malaga", titleRu: "Розы в Малаге — свежие букеты роз с доставкой", titleEn: "Roses in Malaga" },
      { slug: "cvety-v-otel-malaga-marbella", titleRu: "Доставка цветов в отель в Малаге и Марбелье", titleEn: "Hotel Flower Delivery in Malaga & Marbella" },
    ],
  },
  {
    city: "ibiza",
    cityName: "Ибица",
    priority: "P2",
    articles: [
      { slug: "dostavka-tsvetov-na-ibitse-bukety-na-legendarnom-ostrove", titleRu: "Доставка цветов на Ибице — букеты на легендарном острове", titleEn: "Flower Delivery in Ibiza — Bouquets on the Legendary Island" },
      { slug: "dostavka-tsvetov-v-otel-na-ibitse-surpriz-na-otdyhe", titleRu: "Доставка цветов в отель на Ибице — сюрприз на отдыхе", titleEn: "Flower Delivery to Hotels in Ibiza — A Surprise on Vacation" },
      { slug: "wedding-florist-ibiza-venues-pricing-guide", titleRu: "Свадебная флористика на Ибице — площадки, цены и гид по сезонам 2026", titleEn: "Ibiza Wedding Florist — Venues, Pricing and Seasonal Guide 2026" },
      { slug: "svadba-na-ibitse-polnyy-gid-2026", titleRu: "Свадьба на Ибице 2026 — полный гид: сезон, площадки, бюджет и организация", titleEn: "Getting Married in Ibiza 2026 — The Complete Wedding Planning Guide" },
      { slug: "rozy-ibiza", titleRu: "Розы на Ибице — классические букеты с доставкой", titleEn: "Roses in Ibiza" },
      { slug: "romanticheskij-vecher-ibiza", titleRu: "Романтический вечер на Ибице — места и цветы", titleEn: "Romantic Evening in Ibiza" },
      { slug: "zakaty-ibiza-gde-smotret", titleRu: "Закаты Ибицы — лучшие места и романтические идеи", titleEn: "Ibiza Sunsets — Best Spots" },
    ],
  },
  {
    city: "mallorca",
    cityName: "Майорка",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-mallorca", titleRu: "Доставка цветов на Майорке — свежие букеты от €126 по всему острову", titleEn: "Flower Delivery in Mallorca — Fresh Bouquets from €126 Across the Island" },
      { slug: "dostavka-cvetov-mallorca-palma", titleRu: "Доставка цветов в Пальма-де-Майорка — букеты на острове", titleEn: "Flower Delivery in Palma de Mallorca" },
      { slug: "svadba-mallorca-cvety", titleRu: "Свадебные цветы на Майорке — фермы и виллы", titleEn: "Wedding Flowers in Mallorca" },
      { slug: "cvety-v-otel-mallorca", titleRu: "Доставка цветов в отель на Майорке", titleEn: "Hotel Flower Delivery in Mallorca" },
    ],
  },
  {
    city: "costa-brava",
    cityName: "Коста-Брава",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-costa-brava", titleRu: "Доставка цветов на Коста-Браве — свежие букеты от €140 в Льорет, Тоссу, Бегур и Кадакес", titleEn: "Flower Delivery on the Costa Brava — Fresh Bouquets from €140 to Lloret, Tossa, Begur and Cadaqués" },
      { slug: "cvety-v-otel-costa-brava", titleRu: "Доставка цветов в отель на Коста-Брава", titleEn: "Hotel Flower Delivery on Costa Brava" },
      { slug: "svadba-costa-brava-cvety", titleRu: "Свадебные цветы на Коста-Брава — бухты и виллы", titleEn: "Wedding Flowers on Costa Brava" },
      { slug: "rozy-costa-brava", titleRu: "Розы на Коста-Брава — букеты с доставкой", titleEn: "Roses on Costa Brava" },
    ],
  },
  {
    city: "tenerife",
    cityName: "Тенерифе",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-tenerife", titleRu: "Доставка цветов на Тенерифе — свежие букеты от €140 в Коста-Адехе, Лас-Америкас и Пуэрто-де-ла-Крус", titleEn: "Flower Delivery in Tenerife — Fresh Bouquets from €140 to Costa Adeje, Las Américas and Puerto de la Cruz" },
      { slug: "cvety-v-otel-tenerife", titleRu: "Доставка цветов в отель на Тенерифе", titleEn: "Hotel Flower Delivery in Tenerife" },
      { slug: "svadba-tenerife-cvety", titleRu: "Свадебные цветы на Тенерифе — океан и вулкан", titleEn: "Wedding Flowers in Tenerife" },
      { slug: "ekzoticheskie-cvety-tenerife", titleRu: "Экзотические цветы на Тенерифе — стрелиции и протеи", titleEn: "Exotic Flowers in Tenerife" },
    ],
  },
  {
    city: "monaco",
    cityName: "Монако",
    priority: "P2",
    articles: [
      { slug: "dostavka-tsvetov-v-monako-bukety-v-knyazhestve", titleRu: "Доставка цветов в Монако — букеты на самом маленьком и роскошном княжестве мира", titleEn: "Flower Delivery in Monaco — Bouquets in the World's Smallest and Most Luxurious Principality" },
      { slug: "gran-pri-monako-2026-cvety-dostavka", titleRu: "Гран-при Монако 2026 — главное событие лета и цветы, которые его дополнят", titleEn: "Monaco Grand Prix 2026 — the summer's biggest event and the flowers to match" },
      { slug: "kak-organizovat-syurpriz-v-monako", titleRu: "Как организовать сюрприз в Монако: букет, столик, яхта и правильные детали", titleEn: "How to Plan a Surprise in Monaco: the Bouquet, the Table, the Yacht and the Right Details" },
      { slug: "gde-pouzhinat-v-monako", titleRu: "Где поужинать в Монако 2026 — от Alain Ducasse до террас над портом Эркюль", titleEn: "Where to Dine in Monaco 2026 — From Alain Ducasse to Terraces over Port Hercule" },
      { slug: "luchshie-restorany-monako-dlya-romanticheskogo-uzhina", titleRu: "Лучшие рестораны Монако для романтического ужина", titleEn: "Best Restaurants in Monaco for a Romantic Dinner" },
      { slug: "korporativnye-podarki-i-tsvety-v-monako", titleRu: "Корпоративные подарки и цветы в Монако — этикет", titleEn: "Corporate Gifts & Flowers in Monaco" },
      { slug: "cvety-na-yahtu-monako", titleRu: "Цветы на яхту в Монако — Порт-Эркюль", titleEn: "Yacht Flowers in Monaco — Port Hercule" },
    ],
  },
  {
    city: "nice",
    cityName: "Ницца",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-nice", titleRu: "Доставка цветов в Ницце — свежие букеты на Лазурном берегу от €140", titleEn: "Flower Delivery in Nice — Fresh Bouquets on the French Riviera from €140" },
      { slug: "cvety-v-otel-nice-negresco", titleRu: "Доставка цветов в отель в Ницце — Negresco, Anantara", titleEn: "Hotel Flower Delivery in Nice" },
      { slug: "rozy-nice", titleRu: "Розы в Ницце — букеты роз по Лазурному берегу", titleEn: "Roses in Nice" },
      { slug: "cvety-dlya-yahty-nice", titleRu: "Цветы для яхты в Ницце и Антибе", titleEn: "Flowers for a Yacht in Nice & Antibes" },
      { slug: "svadba-nice-cvety", titleRu: "Свадебные цветы в Ницце — Лазурный берег", titleEn: "Wedding Flowers in Nice" },
    ],
  },
  {
    city: "cannes",
    cityName: "Канны",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-cannes", titleRu: "Доставка цветов в Каннах — свежие букеты на Лазурном берегу от €140", titleEn: "Flower Delivery in Cannes — Fresh Bouquets on the French Riviera from €140" },
      { slug: "cvety-v-otel-cannes-carlton-martinez", titleRu: "Доставка цветов в отель в Каннах — Carlton, Martinez", titleEn: "Hotel Flower Delivery in Cannes" },
      { slug: "cvety-na-kinofestival-cannes", titleRu: "Цветы на Каннский кинофестиваль — для звёзд и премьер", titleEn: "Flowers for the Cannes Film Festival" },
      { slug: "cvety-dlya-yahty-cannes", titleRu: "Цветы для яхты в Каннах — Порт-Канто", titleEn: "Flowers for a Yacht in Cannes" },
    ],
  },
  {
    city: "saint-tropez",
    cityName: "Сен-Тропе",
    priority: "P2",
    articles: [
      { slug: "luchshie-restorany-sen-trope", titleRu: "Лучшие рестораны Сен-Тропе 2026 — где ужинают те, кто приплыл на яхте, и те, кто приехал на машине", titleEn: "Best Restaurants in Saint-Tropez 2026 — Where the Yacht Crowd and the Car Crowd Dine" },
      { slug: "dostavka-cvetov-sen-trope", titleRu: "Доставка цветов в Сен-Тропе — букеты на Лазурном берегу", titleEn: "Flower Delivery in Saint-Tropez" },
      { slug: "cvety-na-yahtu-sen-trope", titleRu: "Цветы на яхту в Сен-Тропе — марина и пляжные клубы", titleEn: "Yacht Flowers in Saint-Tropez" },
      { slug: "svadba-sen-trope-cvety", titleRu: "Свадебные цветы в Сен-Тропе — виллы и виноградники", titleEn: "Wedding Flowers in Saint-Tropez" },
    ],
  },
  {
    city: "miami",
    cityName: "Майами",
    priority: "P1",
    articles: [
      { slug: "cvety-na-yahtu-miami", titleRu: "Цветы на яхту в Майами — сюрпризы на воде в Майами-Бич", titleEn: "Flowers for a Yacht in Miami — Surprises on the Water in Miami Beach" },
      { slug: "dostavka-cvetov-miami", titleRu: "Доставка цветов в Майами — букеты в столице солнца и роскоши Флориды", titleEn: "Flower Delivery in Miami — Bouquets in Florida's Capital of Sun and Luxury" },
      { slug: "kak-i-gde-zakazat-cvety-v-miami", titleRu: "Как и где заказать цветы в Майами 2026: полный гид по доставке букетов", titleEn: "How and Where to Order Flowers in Miami 2026: The Complete Delivery Guide" },
      { slug: "cvety-v-otel-miami-faena-fontainebleau", titleRu: "Доставка цветов в отель в Майами — Faena, Fontainebleau", titleEn: "Hotel Flower Delivery in Miami" },
      { slug: "rozy-miami", titleRu: "Розы в Майами — букеты по Саут-Бич и Брикелл", titleEn: "Roses in Miami" },
      { slug: "svadba-miami-cvety", titleRu: "Свадебные цветы в Майами — церемония у океана", titleEn: "Wedding Flowers in Miami" },
      { slug: "cvety-na-den-rozhdeniya-miami", titleRu: "Цветы на день рождения в Майами — топ букетов", titleEn: "Birthday Flowers in Miami" },
    ],
  },
  {
    city: "mykonos",
    cityName: "Миконос",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-mykonos", titleRu: "Доставка цветов на Миконосе — букеты на жемчужине Эгейского моря", titleEn: "Flower Delivery in Mykonos — Bouquets on the Jewel of the Aegean" },
      { slug: "rozy-mykonos", titleRu: "Розы на Миконосе — букеты с доставкой по острову", titleEn: "Roses in Mykonos — Bouquets Delivered Across the Island" },
      { slug: "oteli-na-mikonose-luchshie", titleRu: "Лучшие отели на Миконосе 2026: где остановиться (и как удивить цветами)", titleEn: "Best Hotels in Mykonos 2026: Where to Stay (and How to Surprise with Flowers)" },
      { slug: "luchshie-restorany-mykonos", titleRu: "Лучшие рестораны Миконоса 2026 — Nammos, Scorpios и cocktail-вечера", titleEn: "Best Restaurants in Mykonos 2026 — Nammos, Scorpios & Cocktail Nights" },
      { slug: "den-rozhdeniya-na-mikonoze-villy-yakhty-syurpriz", titleRu: "День рождения на Миконосе — виллы, яхты и как организовать сюрприз", titleEn: "Birthday in Mykonos — Villas, Yachts and How to Organise the Perfect Surprise" },
      { slug: "cvety-v-otel-mykonos", titleRu: "Доставка цветов в отель на Миконосе — Cavo Tagoo, Belvedere", titleEn: "Hotel Flower Delivery in Mykonos" },
      { slug: "svadba-na-mykonose-cvety", titleRu: "Свадебные цветы на Миконосе — церемония над морем", titleEn: "Wedding Flowers in Mykonos" },
      { slug: "tsvety-dlya-jachty-mykonos", titleRu: "Цветы для яхты на Миконосе — сюрпризы на воде", titleEn: "Flowers for a Yacht in Mykonos" },
    ],
  },
  {
    city: "santorini",
    cityName: "Санторини",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-santorini", titleRu: "Доставка цветов на Санторини — букеты на самом фотогеничном острове Греции", titleEn: "Flower Delivery in Santorini — Bouquets on the Most Photographed Island in Greece" },
      { slug: "oteli-na-santorini-luchshie", titleRu: "Лучшие отели на Санторини 2026: где остановиться (и как удивить цветами)", titleEn: "Best Hotels in Santorini 2026: Where to Stay (and How to Surprise with Flowers)" },
      { slug: "cvety-v-otel-santorini-canaves-andronis", titleRu: "Доставка цветов в отель на Санторини — Canaves, Andronis", titleEn: "Hotel Flower Delivery in Santorini" },
      { slug: "predlojenie-ruki-i-serdtsa-santorini", titleRu: "Предложение руки и сердца на Санторини — гид флориста", titleEn: "Marriage Proposal in Santorini" },
      { slug: "svadba-na-santorini-cvety", titleRu: "Свадебные цветы на Санторини — над кальдерой", titleEn: "Wedding Flowers in Santorini" },
      { slug: "medovyy-mesyats-santorini-cvety", titleRu: "Медовый месяц на Санторини — цветы и романтика", titleEn: "Honeymoon in Santorini" },
    ],
  },
  {
    city: "rhodes",
    cityName: "Родос",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-rhodes", titleRu: "Доставка цветов на Родосе — букеты на солнечном острове Додеканеса", titleEn: "Flower Delivery in Rhodes — Bouquets on the Sunniest Island of the Dodecanese" },
      { slug: "cvety-v-otel-rhodes-lindos-sheraton", titleRu: "Доставка цветов в отель на Родосе — Sheraton, Lindian", titleEn: "Hotel Flower Delivery in Rhodes" },
      { slug: "lindos-cvety-rhodes", titleRu: "Линдос — белая жемчужина Родоса и цветочные сюрпризы", titleEn: "Lindos — Floral Surprises in Rhodes" },
      { slug: "svadba-na-rhodes-cvety", titleRu: "Свадебные цветы на Родосе — церемония у моря", titleEn: "Wedding Flowers in Rhodes" },
    ],
  },
  {
    city: "crete",
    cityName: "Крит",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-crete", titleRu: "Доставка цветов на Крите — букеты на крупнейшем острове Греции", titleEn: "Flower Delivery in Crete" },
      { slug: "cvety-v-otel-crete-elounda", titleRu: "Доставка цветов в отель на Крите — Elounda и Ханья", titleEn: "Hotel Flower Delivery in Crete — Elounda & Chania" },
      { slug: "svadba-crete-cvety", titleRu: "Свадебные цветы на Крите — церемония у Эгейского моря", titleEn: "Wedding Flowers in Crete" },
      { slug: "rozy-crete", titleRu: "Розы на Крите — букеты роз с доставкой по острову", titleEn: "Roses in Crete" },
    ],
  },
  {
    city: "lake-como",
    cityName: "Озеро Комо",
    priority: "P2",
    articles: [
      { slug: "svadba-na-ozere-komo", titleRu: "Свадьба на озере Комо: виллы, сезоны, бюджет — полный гайд 2026", titleEn: "A Wedding on Lake Como: Villas, Seasons & Budget — The Complete 2026 Guide" },
      { slug: "dostavka-cvetov-lake-como", titleRu: "Доставка цветов на озере Комо — букеты у виллы", titleEn: "Flower Delivery at Lake Como" },
      { slug: "cvety-v-otel-como-villa-deste", titleRu: "Доставка цветов в отель на Комо — Villa d'Este, Mandarin", titleEn: "Hotel Flower Delivery at Lake Como" },
      { slug: "predlozhenie-lake-como-cvety", titleRu: "Предложение руки и сердца на озере Комо", titleEn: "Marriage Proposal at Lake Como" },
    ],
  },
  {
    city: "amalfi",
    cityName: "Амальфи",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-amalfi", titleRu: "Доставка цветов на Амальфитанском побережье — букеты у моря", titleEn: "Flower Delivery on the Amalfi Coast" },
      { slug: "cvety-v-otel-amalfi-positano", titleRu: "Доставка цветов в отель в Позитано и Амальфи", titleEn: "Hotel Flower Delivery in Positano & Amalfi" },
      { slug: "svadba-amalfi-cvety", titleRu: "Свадебные цветы на Амальфи — Равелло и Позитано", titleEn: "Wedding Flowers on the Amalfi Coast" },
      { slug: "medovyy-mesyats-amalfi-cvety", titleRu: "Медовый месяц на Амальфи — цветы и романтика", titleEn: "Honeymoon on the Amalfi Coast" },
    ],
  },
  {
    city: "bari",
    cityName: "Бари",
    priority: "P3",
    articles: [
      { slug: "kak-zakazat-cvety-v-bari", titleRu: "Как заказать цветы в Бари 2026 — пошаговый гид по доставке букетов", titleEn: "How to Order Flowers in Bari 2026 — A Step-by-Step Delivery Guide" },
      { slug: "dostavka-cvetov-bari", titleRu: "Доставка цветов в Бари — свежие букеты в столице Апулии", titleEn: "Flower Delivery in Bari" },
      { slug: "rozy-bari", titleRu: "Розы в Бари — букеты роз с доставкой", titleEn: "Roses in Bari" },
      { slug: "svadba-apuliya-cvety", titleRu: "Свадебные цветы в Апулии — масерии и побережье", titleEn: "Wedding Flowers in Apulia" },
    ],
  },
  {
    city: "capri",
    cityName: "Капри",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-na-kapri", titleRu: "Доставка цветов на Капри: гид по букетам и романтическим сюрпризам", titleEn: "Flower Delivery on Capri: A Guide to Bouquets and Romantic Surprises" },
      { slug: "cvety-v-otel-capri", titleRu: "Доставка цветов в отель на Капри — Quisisana, Punta Tragara", titleEn: "Hotel Flower Delivery in Capri" },
      { slug: "predlozhenie-capri-cvety", titleRu: "Предложение руки и сердца на Капри — Фаральони", titleEn: "Marriage Proposal in Capri" },
      { slug: "svadba-capri-cvety", titleRu: "Свадебные цветы на Капри — церемония над морем", titleEn: "Wedding Flowers in Capri" },
    ],
  },
  {
    city: "sorrento",
    cityName: "Сорренто",
    priority: "P3",
    articles: [
      { slug: "kak-zakazat-cvety-v-sorrento", titleRu: "Как заказать цветы в Сорренто 2026: пошаговый гид по доставке букетов", titleEn: "How to Order Flowers in Sorrento 2026: A Step-by-Step Flower Delivery Guide" },
      { slug: "dostavka-cvetov-sorrento", titleRu: "Доставка цветов в Сорренто — букеты у Неаполитанского залива", titleEn: "Flower Delivery in Sorrento" },
      { slug: "cvety-v-otel-sorrento", titleRu: "Доставка цветов в отель в Сорренто", titleEn: "Hotel Flower Delivery in Sorrento" },
      { slug: "svadba-sorrento-cvety", titleRu: "Свадебные цветы в Сорренто — вид на Везувий", titleEn: "Wedding Flowers in Sorrento" },
    ],
  },
  {
    city: "tbilisi",
    cityName: "Тбилиси",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-v-gruzii", titleRu: "Доставка цветов в Грузии: Тбилиси и Батуми — полный гид", titleEn: "Flower Delivery in Georgia: Tbilisi and Batumi — The Complete Guide" },
      { slug: "dostavka-cvetov-na-kavkaze", titleRu: "Доставка цветов на Кавказе: Тбилиси, Батуми, Ереван и Баку", titleEn: "Flower Delivery in the Caucasus: Tbilisi, Batumi, Yerevan and Baku" },
      { slug: "dostavka-cvetov-tbilisi", titleRu: "Доставка цветов в Тбилиси — свежие букеты в столице Грузии", titleEn: "Flower Delivery in Tbilisi" },
      { slug: "rozy-tbilisi", titleRu: "Розы в Тбилиси — букеты роз с доставкой по городу", titleEn: "Roses in Tbilisi" },
      { slug: "cvety-na-svadbu-tbilisi", titleRu: "Свадебные цветы в Тбилиси — грузинские традиции", titleEn: "Wedding Flowers in Tbilisi" },
      { slug: "cvety-na-den-rozhdeniya-tbilisi", titleRu: "Цветы на день рождения в Тбилиси — топ букетов", titleEn: "Birthday Flowers in Tbilisi" },
    ],
  },
  {
    city: "batumi",
    cityName: "Батуми",
    priority: "P2",
    articles: [
      { slug: "kak-zakazat-cvety-v-batumi", titleRu: "Как заказать цветы в Батуми 2026: пошаговый гид по доставке букетов", titleEn: "How to Order Flowers in Batumi 2026: A Step-by-Step Flower Delivery Guide" },
      { slug: "dostavka-cvetov-batumi", titleRu: "Доставка цветов в Батуми — букеты на черноморском курорте", titleEn: "Flower Delivery in Batumi" },
      { slug: "rozy-batumi", titleRu: "Розы в Батуми — свежие букеты роз с доставкой", titleEn: "Roses in Batumi" },
      { slug: "cvety-v-otel-batumi", titleRu: "Доставка цветов в отель в Батуми", titleEn: "Hotel Flower Delivery in Batumi" },
    ],
  },
  {
    city: "yerevan",
    cityName: "Ереван",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-yerevan", titleRu: "Доставка цветов в Ереване — свежие букеты в столице Армении", titleEn: "Flower Delivery in Yerevan" },
      { slug: "rozy-yerevan", titleRu: "Розы в Ереване — букеты роз с доставкой по городу", titleEn: "Roses in Yerevan" },
      { slug: "cvety-na-svadbu-yerevan", titleRu: "Свадебные цветы в Ереване — армянские традиции", titleEn: "Wedding Flowers in Yerevan" },
      { slug: "cvety-na-den-rozhdeniya-yerevan", titleRu: "Цветы на день рождения в Ереване — топ букетов", titleEn: "Birthday Flowers in Yerevan" },
    ],
  },
  {
    city: "baku",
    cityName: "Баку",
    priority: "P2",
    articles: [
      { slug: "dostavka-cvetov-baku", titleRu: "Доставка цветов в Баку — свежие букеты в столице Азербайджана", titleEn: "Flower Delivery in Baku" },
      { slug: "rozy-baku", titleRu: "Розы в Баку — букеты роз с доставкой по городу", titleEn: "Roses in Baku" },
      { slug: "cvety-v-otel-baku", titleRu: "Доставка цветов в отель в Баку — Flame Towers, Four Seasons", titleEn: "Hotel Flower Delivery in Baku" },
      { slug: "cvety-na-svadbu-baku", titleRu: "Свадебные цветы в Баку — восточная роскошь", titleEn: "Wedding Flowers in Baku" },
    ],
  },
  {
    city: "budva",
    cityName: "Будва",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-budva", titleRu: "Доставка цветов в Будве — свежие букеты от €126 на Будванской Ривьере", titleEn: "Flower Delivery in Budva — Fresh Bouquets from €126 on the Budva Riviera" },
      { slug: "rozy-budva", titleRu: "Розы в Будве — свежие букеты роз с доставкой", titleEn: "Roses in Budva" },
      { slug: "cvety-v-otel-budva", titleRu: "Доставка цветов в отель в Будве и Свети-Стефан", titleEn: "Hotel Flower Delivery in Budva & Sveti Stefan" },
      { slug: "svadba-budva-cvety", titleRu: "Свадебные цветы в Будве — Адриатическое побережье", titleEn: "Wedding Flowers in Budva" },
    ],
  },
  {
    city: "kotor",
    cityName: "Котор",
    priority: "P3",
    articles: [
      { slug: "luchshie-oteli-kotora-dostavka-cvetov", titleRu: "Лучшие отели Котора и Которского залива 2026: полный гид + доставка цветов", titleEn: "Best Hotels in Kotor and the Bay of Kotor 2026: The Complete Guide + Flower Delivery" },
      { slug: "dostavka-cvetov-kotor", titleRu: "Доставка цветов в Которе — букеты в Которском заливе", titleEn: "Flower Delivery in Kotor" },
      { slug: "cvety-v-otel-kotor-perast", titleRu: "Доставка цветов в отель в Которе и Перасте", titleEn: "Hotel Flower Delivery in Kotor & Perast" },
      { slug: "svadba-kotor-cvety", titleRu: "Свадебные цветы в Которе — фьорд Адриатики", titleEn: "Wedding Flowers in Kotor" },
    ],
  },
  {
    city: "dubrovnik",
    cityName: "Дубровник",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-v-horvatii", titleRu: "Доставка цветов в Хорватии 2026: полный гид по городам Адриатики", titleEn: "Flower Delivery in Croatia 2026: The Complete Adriatic Guide" },
      { slug: "dostavka-cvetov-dubrovnik", titleRu: "Доставка цветов в Дубровнике — букеты в жемчужине Адриатики", titleEn: "Flower Delivery in Dubrovnik" },
      { slug: "cvety-v-otel-dubrovnik", titleRu: "Доставка цветов в отель в Дубровнике", titleEn: "Hotel Flower Delivery in Dubrovnik" },
      { slug: "svadba-dubrovnik-cvety", titleRu: "Свадебные цветы в Дубровнике — Старый город и море", titleEn: "Wedding Flowers in Dubrovnik" },
    ],
  },
  {
    city: "hvar",
    cityName: "Хвар",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-hvar", titleRu: "Доставка цветов на Хваре — букеты на солнечном острове", titleEn: "Flower Delivery in Hvar" },
      { slug: "cvety-v-otel-hvar", titleRu: "Доставка цветов в отель на Хваре", titleEn: "Hotel Flower Delivery in Hvar" },
      { slug: "svadba-hvar-cvety", titleRu: "Свадебные цветы на Хваре — лаванда и Адриатика", titleEn: "Wedding Flowers in Hvar" },
    ],
  },
  {
    city: "krakow",
    cityName: "Краков",
    priority: "P3",
    articles: [
      { slug: "tsvety-dlya-predlozheniya-v-krakove", titleRu: "Цветы для предложения руки и сердца в Кракове: гид по букетам и местам", titleEn: "Marriage Proposal Flowers in Krakow: A Guide to Bouquets and Spots" },
      { slug: "dostavka-cvetov-krakow", titleRu: "Доставка цветов в Кракове — свежие букеты в сердце Польши", titleEn: "Flower Delivery in Krakow" },
      { slug: "rozy-krakow", titleRu: "Розы в Кракове — букеты роз с доставкой по городу", titleEn: "Roses in Krakow" },
      { slug: "cvety-na-den-rozhdeniya-krakow", titleRu: "Цветы на день рождения в Кракове — топ букетов", titleEn: "Birthday Flowers in Krakow" },
    ],
  },
  {
    city: "algarve",
    cityName: "Алгарве",
    priority: "P3",
    articles: [
      { slug: "oteli-i-golf-rezorty-algarve", titleRu: "Лучшие отели и гольф-резорты Алгарве 2026: полный гид по региону", titleEn: "Best Hotels and Golf Resorts in the Algarve 2026: The Complete Regional Guide" },
      { slug: "dostavka-cvetov-v-algarve", titleRu: "Доставка цветов в Алгарве 2026: как быстро заказать букет — полный гид", titleEn: "Flower Delivery in the Algarve 2026: How to Order a Bouquet Fast — The Complete Guide" },
      { slug: "cvety-v-otel-algarve", titleRu: "Доставка цветов в отель в Алгарве — курорты и гольф", titleEn: "Hotel Flower Delivery in the Algarve" },
      { slug: "svadba-algarve-cvety", titleRu: "Свадебные цветы в Алгарве — океан и скалы", titleEn: "Wedding Flowers in the Algarve" },
      { slug: "rozy-algarve", titleRu: "Розы в Алгарве — букеты роз с доставкой", titleEn: "Roses in the Algarve" },
    ],
  },
  {
    city: "belgrade",
    cityName: "Белград",
    priority: "P3",
    articles: [
      { slug: "dostavka-cvetov-na-balkanah", titleRu: "Доставка цветов на Балканах 2026: полный гид по городам Сербии, Черногории и Хорватии", titleEn: "Flower Delivery in the Balkans 2026: The Complete Guide to Serbia, Montenegro and Croatia" },
      { slug: "dostavka-cvetov-v-belgrade", titleRu: "Доставка цветов в Белграде 2026: как быстро заказать букет — полный гид", titleEn: "Flower Delivery in Belgrade 2026: How to Order a Bouquet Fast — The Complete Guide" },
      { slug: "dostavka-cvetov-belgrade", titleRu: "Доставка цветов в Белграде — свежие букеты в столице Сербии", titleEn: "Flower Delivery in Belgrade" },
      { slug: "rozy-belgrade", titleRu: "Розы в Белграде — букеты роз с доставкой по городу", titleEn: "Roses in Belgrade" },
      { slug: "cvety-na-den-rozhdeniya-belgrade", titleRu: "Цветы на день рождения в Белграде — топ букетов", titleEn: "Birthday Flowers in Belgrade" },
    ],
  },
  {
    city: "",
    cityName: "Общие статьи",
    priority: "P3",
    articles: [
      { slug: "kak-vybrat-buket", titleRu: "Как выбрать идеальный букет — полный гид", titleEn: "How to Choose the Perfect Bouquet — Complete Guide" },
      { slug: "dostavka-cvetov-za-rubezh", titleRu: "Как заказать доставку цветов за границу — полный гид", titleEn: "How to Order International Flower Delivery — Complete Guide" },
      { slug: "kak-sohranit-buket-svezhim-dolshe", titleRu: "Как сохранить букет свежим дольше — 10 проверенных советов", titleEn: "How to Keep a Bouquet Fresh Longer — 10 Proven Tips" },
      { slug: "znachenie-cvetov", titleRu: "Значение цветов — что говорит каждый цвет", titleEn: "Flower Meanings — What Each Color Says" },
      { slug: "top-povodov-podarit-cvety", titleRu: "15 поводов подарить цветы (и 5 поводов — без повода)", titleEn: "15 Reasons to Give Flowers (and 5 Without a Reason)" },
      { slug: "cvety-v-podarok-kollegam", titleRu: "Цветы в подарок коллегам — этикет и лучшие варианты букетов", titleEn: "Flowers as a Gift for Colleagues — Etiquette & Best Options" },
      { slug: "chto-podarit-zhenshchine-na-den-rozhdeniya", titleRu: "Что подарить женщине на день рождения — 20 идей, которые точно понравятся", titleEn: "What to Give a Woman for Her Birthday — 20 Ideas She'll Truly Love" },
      { slug: "cvety-po-znaku-zodiaka", titleRu: "Какие цветы подарить по знаку зодиака", titleEn: "Flowers by Zodiac Sign" },
      { slug: "cvety-dlya-muzhchin", titleRu: "Какие цветы дарить мужчинам — гид по мужским букетам", titleEn: "Flowers for Men — A Guide" },
      { slug: "sezonnost-cvetov-kogda-chto-darit", titleRu: "Сезонность цветов — какие букеты доступны в какой месяц", titleEn: "Flower Seasonality by Month" },
      { slug: "cvety-na-den-materi", titleRu: "Цветы на День матери — лучшие идеи букетов", titleEn: "Mother's Day Flowers — Best Ideas" },
      { slug: "cvety-na-novyi-god-rozhdestvo", titleRu: "Новогодние и рождественские букеты — идеи и тренды", titleEn: "New Year & Christmas Bouquets" },
    ],
  },
];
